import { Home, Users, Wallet, FileText, DollarSign, LucideIcon } from "lucide-react";

export type RouteConfig = {
  icon: LucideIcon;
  title: string;
  subtitle: string;
}

export const routeConfigs: Record<string, RouteConfig> = {
  '/dashboard': {
    icon: Home,
    title: 'Backoffice Dashboard',
    subtitle: 'System administration overview'
  },
  '/dashboard/home': {
    icon: Home,
    title: 'Dashboard',
    subtitle: 'System administration overview'
  },
  '/dashboard/users': {
    icon: Users,
    title: 'Users',
    subtitle: 'Manage system users'
  },
  '/dashboard/wallets': {
    icon: Wallet,
    title: 'Wallets',
    subtitle: 'Manage user wallets'
  },
  '/dashboard/ledger-accounts': {
    icon: FileText,
    title: 'Ledger Accounts',
    subtitle: 'Manage ledger accounts'
  },
  '/dashboard/finance': {
    icon: DollarSign,
    title: 'Finance',
    subtitle: 'Wallet balance, fees & settings'
  },
};

export const getRouteConfig = (pathname: string): RouteConfig => {
  // Try exact match first
  if (routeConfigs[pathname]) {
    return routeConfigs[pathname];
  }

  // Try partial match for dynamic routes
  const matchedRoute = Object.keys(routeConfigs).find(route =>
    route !== '/dashboard' && pathname.startsWith(route)
  );

  return matchedRoute ? routeConfigs[matchedRoute] : routeConfigs['/dashboard'];
};
